import { StoryModel } from '../models/story.model';
import { StoryType } from '../models/story-type.enum';
import { StoryLoadTypeEnum } from '../models/story-load-type.enum';
import { StoryChunkLoadModel } from './story.state.model';

export class FetchStory {
  static readonly type = '[Story] Fetch';
  constructor(public id: string, public type: StoryType) { }
}

export class LoadStory {
  static readonly type = '[Story] Load Current Story';
  constructor(public id: string, public type: StoryType) {}
}

export class AddToStory {
  static readonly type = '[Story] Add to current story';
  constructor(public id: string, public type: StoryType) {}
}

export class SetStory {
  static readonly type = '[Story] Replace the Story';
  constructor(public story: StoryModel) {}
}

export class SetStoryId {
  static readonly type = '[Story] Set the Story ID';
  constructor(public id: string) {}
}

export class SetStoryText {
  static readonly type = '[Story] Set Story Text';
  constructor(public displayName: string) {}
}

export class SetIncomingStory {
  static readonly type = '[Story] Set Incoming Story Id';
  constructor(public id: string, public type: StoryType, public reset?: boolean) {}
}

export class LoadStoryChunk {
  static readonly type = '[Story] Load Story Chunk';
  constructor() {}
}

export class LoadStoryChunkSuccess {
  static readonly type = '[Story] Load Story Chunk Success';
  constructor(public chunk: StoryChunkLoadModel) {}
}

export class BuildStory {
  static readonly type = '[Story] Build Story In Engine From Story Model';
  constructor(public id: string, public story: StoryModel, public type: StoryType, public loadType: StoryLoadTypeEnum, public chapterIdx?: number) {}
}




export class UnloadStory {
  static readonly type = '[Story] Unload And Destroy Story in Engine';
  constructor(public id?: string) {}
}

export class LoadStorySuccess {
  static readonly type = '[Story] Load Success';
  constructor(public story: StoryModel, public id: string, public type: StoryType) { }
}

export class LoadStoryFail {
  static readonly type = '[Story] Load Fail';
  constructor(public id: string, public type: StoryType) { }
}

export class ImportStory {
  static readonly type = '[Story] Import';
  constructor(public id: string, public type: StoryType) { }
}

export class ImportStorySuccess {
  static readonly type = '[Story] Import Success';
  constructor(public story: StoryModel, public id: string, public type: StoryType) { }
}

export class ResetStory {
  static readonly type = '[Story] Clear';
  constructor() { }
}

export class SynchronizeChapters {
  static readonly type = '[Story] Synchronize Chapters';
  constructor() { }
}

